export class FixturePath {
  private _segments: readonly string[] | undefined;

  constructor(readonly value: string) {}

  get segments(): readonly string[] {
    return (this._segments ??= this.value.split('/'));
  }

  toString(): string {
    return this.value;
  }
}
